<template>
  <v-container>
    <v-row align="center">
      <v-col cols="12" class="text-center">
        <h3 v-html="title"></h3>
        <p>{{ text }}</p>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="6"
        md="4"
        v-for="(item, index) in list"
        :key="index"
        data-aos="zoom-in"
        :data-aos-delay="$vuetify.breakpoint.mdAndUp ? 300 * index : 0"
      >
        <v-card class="mx-auto" contain>
          <v-img height="200px" :src="require(`@/assets/${item.img}`)"></v-img>
          <v-card-title class="justify-center">
            <h4>{{ item.type }}</h4>
          </v-card-title>
          <v-card-subtitle class="pb-0">
            <h3 :style="`color:${color}`" class="text-center">
              {{ item.location }}
            </h3>
          </v-card-subtitle>
          <v-card-text class="text--primary text-center">
            <div>
              {{ item.price }}€ | {{ item.surface }}M&#xB2; | rèf:{{ item.ref }}
            </div>
          </v-card-text>

          <v-card-actions class="pb-5">
            <v-spacer></v-spacer>
            <v-btn :color="color">En savoir +</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="mt-5">
      <v-spacer></v-spacer>
      <v-btn :color="color" large>voir plus de biens</v-btn>
      <v-spacer></v-spacer>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: {
    title: String,
    text: String,
    list: Array,
    color: String
  }
};
</script>
